(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CentroDocenteController', CentroDocenteController);

    CentroDocenteController.$inject = ['CentroDocente'];

    function CentroDocenteController(CentroDocente) {

        var vm = this;

        vm.centroDocentes = [];

        loadAll();

        function loadAll() {
            CentroDocente.query(function(result) {
                vm.centroDocentes = result;
                vm.searchQuery = null;
            });
        }
    }
})();
